// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3UQPH","text":"SelectPayment_text__ycLWU","title":"SelectPayment_title__18yby","btn":"SelectPayment_btn__2nO90"};